import React, { PureComponent } from 'react';
import { Tabs, Card } from 'antd';
import { KLineSubscription } from './klinesubscription';
import { Migration } from './migration';
import { AUTH } from '../../utils/menu'
import auth from '../../utils/auth';

const { TabPane } = Tabs;
class KLine extends PureComponent {
  state = {
    activeKey: 'subscription',
  };

  onChangeTab = (activeKey) => {
    this.setState({ activeKey });
  };

  componentDidMount = (xxx) => {
    const hasAuthSubscription = (auth.checkAuth([AUTH.HK_KLINE.key, AUTH.US_KLINE.key]));
    const hasAuthMigration = auth.checkAuth([AUTH.MIGRATION.key]);
    this.setState({ hasAuthMigration, hasAuthSubscription });
    this.setState({ activeKey: hasAuthSubscription ? 'subscription' : hasAuthMigration ? 'migration' : '' })

  }
  render() {
    const { activeKey, hasAuthSubscription, hasAuthMigration } = this.state;

    return (
      <Card>
        <Tabs activeKey={activeKey} onChange={this.onChangeTab}>
          {hasAuthSubscription && <TabPane tab="订阅" key="subscription">
            <KLineSubscription />
          </TabPane>}
          {hasAuthMigration && <TabPane tab="迁移" key="migration">
            <Migration />
          </TabPane>}
        </Tabs>
      </Card>
    );
  }
}

export default KLine;
